//  @flow

import * as React from 'react';

import ShortText from '../ShortText';
import ImageBlurFallback from '../ImageBlurFallback';

import './style.css';

type ImageCardProps = {
  image?: string,
  webpImage?: string,
  title?: string,
  text?: string,
  children?: React.Node,
  hidden?: boolean,
  showImage?: boolean,
  className: string | '',
  onImageLoad: () => void
};

const ImageCard = (props: ImageCardProps) => {
  const {
    image,
    webpImage,
    text,
    title,
    children,
    hidden,
    className,
    fallbackImage,
    onClick
  } = props;
  return (
    <div
      onClick={onClick}
      role="button"
      className={`image-card ${className} ${hidden ? 'hidden' : ''}`}>
      <ImageBlurFallback
        fallbackImage={fallbackImage}
        className="image-card-img"
        webpImage={webpImage}
        src={image}
        alt="course"
      />
      <div className="image-card-content-box">
        <div className="image-card-content">
          <p>{title}</p>
          <ShortText text={text}>{val => <span>{val}</span>}</ShortText>
        </div>
        {children}
      </div>
    </div>
  );
};

ImageCard.defaultprops = {
  hidden: false,
  showImage: true,
  className: '',
  onClick: () => {},
  fallbackImage: ''
};

export default ImageCard;



// WEBPACK FOOTER //
// ./src/Components/ImageCard/index.js